@if (showLoader) {
<app-loader></app-loader>
}
<div class="w-100">
  @if (showGrid) {
<ejs-grid
      [enableVirtualization]="false"
      [enableInfiniteScrolling]="true"
      [enableVirtualMaskRow]="false"
      [enablePersistence]="true"
      [infiniteScrollSettings]="infiniteScrollSettings"
      [allowPaging]="false"
      #bpGrid
      [id]="gridName"
     
      [dataSource]="businessPartners"
      [height]="gridHeight"
      [allowFiltering]="true"
      [allowSorting]="true"
      [allowResizing]="true"
      [pageSettings]="pageSettings"
      [showColumnChooser]="true"
      [allowReordering]="true"
      [searchSettings]='searchSettings'
      [allowExcelExport]="true"
      [editSettings]="{ allowEditing: false }"
      [filterSettings]="{ type: 'Menu' }"
      (rowDataBound)="onRowDataBound($event)"
      (commandClick)="onCommandClick($event, bpGrid)"
      (actionFailure)="onActionFailure($event)"
      (actionBegin)="onGridActionBegin($event)"
      (actionComplete)="onGridActionComplete($event, bpGrid)"
      (toolbarClick)="onToolbarClick($event)"
      (created)="onGridCreated($event)"
      (dataBound)="onDataBound()"
      (excelQueryCellInfo)="onExcelQueryCellInfo($event)"

      >
      <e-columns>
          @for (column of columns; track column) {
<e-column
             
              [field]="column.field"
              [headerText]="column.headerText"
              [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
              [type]="column.type"
              [width]="column.width"
              [filter]="column.filter ? column.filter : { type: 'Menu' }"
              [format]="column.format ? column.format : null"
              [textAlign]="column.textAlign"
              [showInColumnChooser]="column.showInColumnChooser"
              [visible]="column.visible"
              [commands]="column?.commands ? column.commands : null"
              [edit]="column.edit"
              [allowReordering]="column.allowReordering ?? true"
              [freeze]="column.freeze ? column.freeze: null"
              [allowEditing]="column.allowEditing"
              [allowSorting]="column.allowSorting"
              [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">

                @if (column.field === ProspectFields.bpStatus) {
<ng-template #template let-data>
                  <span class="grid-status-column {{getStatusClass(data[ProspectFields.bpStatus])}}">
                      {{data[ProspectFields.bpStatus]}}
                  </span>
              </ng-template>
}
              @if (column.field === ProspectFields.bpName) {
<ng-template #template let-data>
                  <a href="javascript:" (click)="onHyperLinkClick(data)">
                    {{data[ProspectFields.bpName]}}</a>
              </ng-template>
}
              @if (column.field === ProspectFields.lnId) {
<ng-template #template let-data>
                  <a href="javascript:" (click)="onHyperLinkClick(data)">
                    {{data[ProspectFields.lnId]}}</a>
              </ng-template>
}
              @if (column.field === ProspectFields.bpId) {
<ng-template #template let-data>
                  <a href="javascript:" (click)="onHyperLinkClick(data)">
                    {{data[ProspectFields.bpId]}}</a>
              </ng-template>
}
              @if (column.field === ProspectFields.streetAddress) {
<ng-template #template let-data>
                  {{getStreetAddress(data)}}
              </ng-template>
}
          </e-column>
}
      </e-columns>
  </ejs-grid>
}
  @if (showGrid) {
<div class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
    <div class="grid-total-count" style="font-weight:600;">
      Total Records: {{totalRecords | number}}
    </div>
  </div>
}
</div>

<ng-template #columnChooser>
  <app-column-chooser
      [grid]="bpGrid"
  ></app-column-chooser>
</ng-template>

<!-- <ng-template #gridTotal>
  <div class="grid-total-count" style="padding:0 12px; font-weight:600;">
    Total2: {{totalRecords | number}}
  </div>
</ng-template> -->


<!-- <app-prospects-popup
  *ngIf="showProspectsPopup"
  [prospectData]="prospectData"
  [tab]="tab"
  (onClose)="onClose($event)">
</app-prospects-popup> -->

